import { useEffect, useState } from "react";
import ListDataProjectJobEnquiry from "./ListDataProjectJobEnquiry";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import JobEnquiryEdit from "./JobEnquiryEdit/JobEnquiryEdit";
import JobEnquiryCreate from "./JobEnquiryCreate/JobEnquiryCreate";

export default function JobEnquiry({}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [JobEnquiryInputValue] = useOutletContext();
  const toggleJobEnquiryUpdate = useOutletContext()[1];
  const { job_enquiry_list, nationality } = JobEnquiryInputValue || {};

  const [jobEnquiryDetails, setJobEnquiryDetails] = useState({ id: "" });
  const [loading] = useState(false);

  useEffect(() => {
    if (
      location.pathname.split("/").at(-1) === "edit" &&
      !jobEnquiryDetails.id
    ) {
      navigate("");
    }
  }, []);

  return (
    <>
      {location.pathname.split("/").at(-1) == "create" ? (
        <JobEnquiryCreate />
      ) : location.pathname.split("/").at(-1) === "edit" &&
        jobEnquiryDetails.id ? (
        <JobEnquiryEdit
          jobEnquiryId={jobEnquiryDetails.id}
          setJobEnquiryDetails={setJobEnquiryDetails}
        />
      ) : (
        <div className="w-full">
          <ListDataProjectJobEnquiry
            toggleJobEnquiryUpdate={toggleJobEnquiryUpdate}
            setJobEnquiryDetails={setJobEnquiryDetails}
            titles={[
              "S.NO.",
              "JOB ENQUIRY NO",
              "JOB ENQUIRY NAME",
              "DESCRIPTION",
              "NATIONALITY",
              "TOTAL QUANTITY",
              "ACTION",
            ]}
            jobEnquiries={job_enquiry_list}
            loading={loading}
            nationality={nationality}
          />
        </div>
      )}
    </>
  );
}
